module.exports = __webpack_public_path__ + "img/DesertCombatArmor.d0166976.gif";